export default __webpack_public_path__ + "resources/icons/n400-4020.png";